import { Directive, input, numberAttribute } from '@angular/core';

@Directive()
export abstract class SvgComponent {
  color = input<string>('var(--neutral-color-900)');
  size = input(24, { transform: numberAttribute });
}

export const svgBaseStyles = `
    :host {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  `;
